import { TranslateService } from '@ngx-translate/core';
import { COUNTRY_CODE, RmsContractBalance, ContractOP } from '@cemex-core/cmx-api';

import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/select-option-i';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

export function rmsLoadAvailableContracts(
  contracts: ContractOP[],
  contractsBalance: { [contractCode: string]: RmsContractBalance[] },
  translate: TranslateService,
  withBalanceOnly = true,
  country: string,
): SelectOptionI[] {
  if (withBalanceOnly) {
    // Filter out contracts without balance that are supposed to have

    contracts = contracts.filter(contract => {
      const agreement = contractsBalance[contract.contractCode.replace(/^0+/, '')];

      if (_safe(() => agreement[0].agreementItems[0].hasBalance)) {
        return !!contractsBalance[contract.contractCode.replace(/^0+/, '')];
      } else {
        return country === COUNTRY_CODE.MEXICO ? true : false;
      }
    });
  }

  // Return select options
  return contracts.map(salesDocument => {
    return {
      id: salesDocument.contractCode.replace(/^0+/, ''),
      name: description(salesDocument, contractsBalance, translate, country),
    };
  });
}

function description(
  salesDocument: ContractOP,
  contractsBalance: { [contractCode: string]: RmsContractBalance[] },
  translate: TranslateService,
  country: string,
): string {
  const name = `${translate.instant('views.specifications.contract')} ${salesDocument.contractCode}`;
  const remainingVolume = contractsBalance[salesDocument.contractCode.replace(/^0+/, '')];
  if (_safe(() => remainingVolume[0].agreementItems[0].quantity)) {
    return `${name}  ‏‏‎  ‏‏‎  ‏‏‎  ${translate.instant('views.specifications.remaining_volume')}
    ${remainingVolume[0].agreementItems[0].quantity} ${
      country === COUNTRY_CODE.USA ? UNITS.CUBIC_YARD : UNITS.CUBIC_METERS
    }`;
  } else {
    return name;
  }
}
